import React from 'react'
import { SvgIcon } from '../../../common/SvgIcon'
import { simpleIconPropsTypes } from '../../propTypes'

export const IconEventManagement = props => {
  const { width = 24, height = 24 } = props

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 24 24">
      <path d="M19 4H18V2H16V4H8V2H6V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM11 13H13V15H15V17H13V19H11V17H9V15H11V13Z" />
    </SvgIcon>
  )
}

IconEventManagement.propTypes = simpleIconPropsTypes
